import React from "react";
import styles from "./LoadingSpinner.module.css";

interface LoadingSpinnerProps {
    size?: "small" | "medium" | "large";
    color?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ size = "medium", color }) => {
    const spinnerSizeClass = styles[size] || styles.medium;

    return (
        <div className={styles.spinnerContainer}>
            <div
                className={`${styles.spinner} ${spinnerSizeClass}`}
                style={color ? { borderColor: `${color} transparent transparent transparent` } : undefined}
            />
        </div>
    );
};

export default LoadingSpinner;
